class SortPopover extends HTMLElement {
  constructor() {
    super();

    const customSelect = document.querySelector(".custom-select");
    const selectBtn = document.querySelector(".select-button");

    // add a click event to select button
    selectBtn.addEventListener("click", (evt) => {
      evt.preventDefault();
      // add/remove active class on the container element
      customSelect.classList.toggle("active");
      // update the aria-expanded attribute based on the current state
      selectBtn.setAttribute(
        "aria-expanded",
        selectBtn.getAttribute("aria-expanded") === "true" ? "false" : "true"
      );
    });

    document.addEventListener('click', (event) => {
      if (!event.composedPath().includes(this)) {
        // add/remove active class on the container element
        customSelect.classList.remove("active");
        // update the aria-expanded attribute based on the current state
        selectBtn.setAttribute(
          "aria-expanded",
          selectBtn.getAttribute("aria-expanded") === "false"
        );
      }
    });

    var inputs = document.querySelectorAll('[name="sort_by"').forEach((item) => {
      item.addEventListener('change', function() {
        var searchParams = new URLSearchParams(window.location.search);
        searchParams.set("sort_by", item.value);
        window.location.href = location.protocol + '//' + location.host + location.pathname + "?" + searchParams.toString()
      })
    })
  }
}

customElements.define('sort-popover', SortPopover);
